import { render, staticRenderFns } from "./form_btn.vue?vue&type=template&id=c82efcee&"
var script = {}
import style0 from "./form_btn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports